export enum INCLUSION {
  INC = "Included",
  EXC = "Excluded",
}

export interface IInsightsPayload {
  executionId: string;
  included: boolean;
  ids: string[];
  type: string;
}

export interface IInsightValue {
  name: string;
  count: string;
  total: string;
}

export interface IInsightsResults {
  name: string;
  columnNames: string[];
  values: IInsightValue[];
}
